<template>
    <div class="mainPart">
        <section>
            <!--S 检索-->
            <el-form :model="searchForm" inline class="searchForm">
                <el-form-item label="对账记录生成时间区间">
                    <!-- S 双日期选择器 -->
                    <TwoDatePicker
                        :noQuick="1"
                        @twoDateObtain="twoDateReceive"
                        :startvaldate="searchForm.batchTime.length>0?searchForm.batchTime[0]:''"
                        :endvaldate="searchForm.batchTime.length>0?searchForm.batchTime[1]:''" >
                    </TwoDatePicker>
                    <!-- E 双日期选择器 -->
                </el-form-item>
            <el-form-item label="收款状态">
                <el-select v-model="searchForm.settlestate" placeholder="请选择" clearable>
                    <el-option label="待收款" :value="0"></el-option>
                    <el-option label="已收款" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="结算结果" class="formTimeSlot">
                <el-select v-model="searchForm.nettingstate" placeholder="请选择" clearable>
                    <el-option label="待收款" :value="0"></el-option>
                    <el-option label="待付款" :value="1"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item class="serialInput" label="收款金额区间">
                <em>￥</em>
                <el-input v-model="searchForm.startnetting" clearable placeholder="收款金额最小值" maxlength="9"></el-input>
                <small>~</small>
                <em>￥</em>
                <el-input v-model="searchForm.endnetting" clearable placeholder="收款金额最大值" maxlength="9"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySearch">查询</el-button>
                <el-button type="primary" plain @click="toPrinting" v-if="warningPendingPayinfoList.length">导出</el-button>
                <el-button type="info" disabled v-else>导出</el-button>
                <el-button type="primary" plain @click="specMange = true">任务列表</el-button>
            </el-form-item>
            </el-form>
            <!--S 列表-->
            <el-table ref="gsTable" class="gsTable comTable" border :data="warningPendingPayinfoList" :maxHeight="tableHeight" v-loading="listLoading">
                <el-table-column type="index" label="序号" width="60" fixed="left"></el-table-column>
                <el-table-column label="对账记录生成时间" min-width="170">
                    <template slot-scope="scope">
                        <p>{{dateTime(scope.row.batchdate,1)}}</p>
                        <p v-if="(scope.row.state==3 || scope.row.state==5)&&(scope.row.settlestate==0 || scope.row.settlestate==2)">对账状态：<span class="redColor">{{scope.row.state==3?'已完成':'异常结束'}}</span></p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡提货时间区间" min-width="210">
                    <template slot-scope="scope">
                        <p>{{dateTime(scope.row.startpickdate) || '系统创建时间'}} ~ {{dateTime(scope.row.endpickdate)}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="收款状态" min-width="130">
                    <template slot-scope="scope">
                        <span :class="returnSettlestateNameOrClass(scope.row.settlestate,1)">{{returnSettlestateNameOrClass(scope.row.settlestate)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="需收款金额（￥）" min-width="150">
                    <template slot-scope="scope">
                        <span class="cityName iconhand" @click="viewAccountSetail(scope.row)" v-if="scope.row.amount!='0'">{{scope.row.amount}}</span>
                        <span class="cityName" v-else>{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际收款时间" min-width="200">
                    <template slot-scope="scope">
                        <div class="categorycode ">
                            <p>{{dateTime(scope.row.settledate,1) ||'--'}}</p>
                            <small class="txtLineTwo greyColor" :title="scope.row.settlememo" v-if="scope.row.settlememo">备注：{{scope.row.settlememo||'--'}}</small>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="150">
                    <template slot-scope="scope">
                        <div class="categorycode ">
                            <p v-if="scope.row.settlestate==0&&scope.row.state==2" class="blueColor cityName" @click="settlement(scope.row)">完成收款</p>
                            <p v-else>--</p>
                        </div>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        </section>
    
        <!--S 收付款明细弹窗-->
        <DetailPopup :showpopup="showpopup" :directDetail="directDetail"  @DialogVisible="DialogVisible"></DetailPopup>
        <!--E 收付款明细弹窗-->

        <!-- S 任务列表弹窗 -->
        <TaskList :isStatistics="1" :specMange="specMange" :eleType="17" typeName="xdh" @closeTask="closeTask"></TaskList>
        <!-- E 任务列表弹窗 -->

        <el-dialog :visible.sync="orderMemoBox" class="comDlog lowerMdg" :before-close="closeOMemoBox" append-to-body :close-on-click-modal="false">
            <div slot="title" class="dialog-title">完成收款</div>
            <el-form ref="form_ref" :model="lmemoForm" @submit.native.prevent>
                <div>
                    <el-form-item>
                        <em></em>备注不得超过 <em>100</em>字
                    </el-form-item>
                    <el-form-item>
                        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" maxlength="100" show-word-limit placeholder="填写备注" v-model="lmemoForm.memo"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="determineloading" @click="submitMemoChnage()">确定</el-button>
                <el-button @click="closeOMemoBox" :disabled="determineloading">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { MessageBox } from "element-ui";
import Api from '@/apis/api.js';
export default {
name:'DealerReconciliation',
data () {
    return {
        storeChoseDialogVisible:false,//检索选择经销商
        searchForm:{
            batchTime: [], // 检索的对账记录生成时间区间
            settlestate: '',
            nettingstate:'',
            startnetting:'',
            endnetting:'',
        },
        currentBatchInfo:{},//当前批次
        tableHeight: window.innerHeight*.8, //表格动态高度
        currentPage:1,
        pageSize:30,
        pagebBean:{
            totalnum: 0,
        },//分页
        warningPendingPayinfoList: [], // 待结算列表
        listLoading: false, // 加载中弹窗显示和隐藏
        subLoading:false,//防连点
        showpopup:false,
        directDetail:'',
        specMange:false, //任务列表弹窗
        printingShow: true, // 防止多次点击导出按钮
        determineloading: false,
        settleitem: '',
        orderMemoBox: false,
        lmemoForm: {
            memo: ''
        },
    }
},
filters: {

},
components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
    DetailPopup: resolve => require(["./DetailPopup.vue"], resolve),
    TaskList: resolve =>require(["@/components/StatisticsFolder/TaskList.vue"], resolve), // 任务列表组件
},
// ============================================== 监听 ==============================================
watch: {
    'searchForm.startnetting'(val) {
        this.searchForm.startnetting = this.amountChech(val);
    },
    'searchForm.endnetting'(val) {
        this.searchForm.endnetting = this.amountChech(val);
    },
},
// ============================================== 方法 ==============================================
methods: {
    settlement(item) {
        this.settleitem = item
        this.lmemoForm.memo = ''
        this.orderMemoBox = true
        this.determineloading = false
    },
    closeOMemoBox() {
        this.orderMemoBox = false
    },
    submitMemoChnage() {
        if(this.determineloading) {
            return;
        }
        let parem = {
            settlecode: this.settleitem.settlecode,
            infocode: this.settleitem.infocode,
            settlememo: this.lmemoForm.memo
        }
        this.determineloading = true
        Api.HBGNETTINGCOMPLETE(parem).then(res => {
            if (res.data.status == "200") {
                this.$message.success(res.data.message)
                this.getStoreBillHistoryList();
                this.determineloading = false
                this.orderMemoBox = false
            } else {
                this.determineloading = false
                this.$alert(res.data.message, '系统提示', {
                    dangerouslyUseHTMLString: true,
                    type: 'warning',
                    callback: action => {
                        this.orderMemoBox = false
                    }
                });
            }
        }).catch((err) => {
            this.determineloading = false
        })
    },
    // 打印操作确认事件
    toPrinting(type) {
        if(this.printingShow) {
            let queryParams = this.returnQueryInfo();
            queryParams.type = 1;
            if(type == 1) {
                if(this.multipleSelection&&this.multipleSelection.length>0) {
                    queryParams.exceltype = 1;
                    let alltotales = '';
                    this.multipleSelection.forEach(item => {
                        if(alltotales!=='') {
                            alltotales = alltotales + ',' + item.orderno;
                        } else {
                            alltotales = item.orderno;
                        }
                    })
                    this.loading = true;
                    this.printingShow = false;
                    queryParams.alltotale = alltotales;
                    this.getUrlForStoreBillHistoryList(queryParams);
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请至少勾选一项！'
                    })
                }
            } else {
                this.loading = true;
                this.printingShow = false;
                // queryParams.exceltype = 0;
                this.getUrlForStoreBillHistoryList(queryParams);
            }
        }
    },
    // 获取兑换礼券统计详细列表信息下载地址
    getUrlForStoreBillHistoryList(params) {
        Api.GET_URLFORSTOREBILLHISTORYLIST(params).then(res => {
            this.printingShow = true;
            if(res.data.status == "200") {
                if(res.data.data && res.data.data.indexOf('http')!=-1) {
                    window.location.href = res.data.data;
                    this.$message({
                        type: 'success',
                        message: res.data.message
                    })
                    // this.closeExport();
                } else {
                    MessageBox.confirm(`${res.data.message}`, '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'success'
                    }).then(() => {
                        // this.closeExport();
                    }).catch(() => {})
                }
            } else {
                this.$message({
                    type: 'error',
                    message: res.data.message
                })
            }
            this.loading = false;
        }).catch(res => {
            this.printingShow = true;
            this.loading = false;
        })
    },
    // 关闭任务列表弹窗
    closeTask() {
        this.specMange = false;
    },
    // 过滤结算状态和样式
    returnSettlestateNameOrClass(state,type) {
        if(state == 0) {
            return type!=1?'待收款':'orangeColor';
        } else if(state == 1) {
            return type!=1?'已收款':'greenColor';
        } else if(state == 2) {
            return type!=1?'部分收款':'redColor';
        } else if(state == 3) {
            return type!=1?'无需收款':'greyColor';
        }
    },
    viewAccountSetail(row){
        this.directDetail = row;
        this.showpopup = true;
        sessionStorage.setItem('batchItemDetail',JSON.stringify(row)); // 用于券卡明细查询使用
    },
    DialogVisible(type){
        this.showpopup = type;
        this.getStoreBillHistoryList();
    },
    // 接收选中的日期
    twoDateReceive(info) {
      if(info&&info.length>0) {
        this.searchForm.batchTime[0] = info[0];
        this.searchForm.batchTime[1] = info[1];
      } else {
        this.searchForm.batchTime = [];
      }
    },
    // 检索确定事件
    querySearch() {
        this.currentPage = 1;
        this.getStoreBillHistoryList();
    },
    // 返回请求参数
    returnQueryInfo() {
        let detailParams = {
            sbatchdate: this.searchForm.batchTime.length>0?(this.dateTime(this.searchForm.batchTime[0])+' 00:00:00'):'',
            ebatchdate: this.searchForm.batchTime.length>0?(this.dateTime(this.searchForm.batchTime[1])+' 23:59:59'):'',
            state: this.searchForm.settlestate!==''?this.searchForm.settlestate:null,
            nettingstate: this.searchForm.nettingstate!==''?this.searchForm.nettingstate:null,
            startnetting: this.searchForm.startnetting,
            endnetting: this.searchForm.endnetting,
        };
        return detailParams;
    },
    //门店对账历史记录列表
    getStoreBillHistoryList(){
        let params = this.returnQueryInfo();
        params.pageparam ={
            pagesize: this.pageSize, //每页条数
            currentpage: this.currentPage, //当前页数
            isnewcomp: 1 //是否需要重新统计页数
        }
        this.listLoading = true;
        Api.GET_HBGSTOREBILLHISTORYLIST(params).then(res => {
            if(res.data.status == '200'){
                if(res.data.data && res.data.data != 'null' && res.data.data.length){
                    let list = res.data.data;
                    list.forEach(item => {
                    if(item.amount.indexOf('-')!=-1) {
                        item.amount = item.amount.split('-')[1];
                    }
                    })
                    this.warningPendingPayinfoList = list;
                }else{
                    this.warningPendingPayinfoList = [];
                }
                this.pagebBean = res.data.pagebean;
            }
            this.listLoading = false;
        }).catch(res => {
            this.listLoading = false;
        })
    },
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getStoreBillHistoryList();
    },
    //动态获取表格高度
    getHeight() {
        let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
        this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
    
},
created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
},
mounted () {
    //门店对账历史记录列表
    this.getStoreBillHistoryList()
    //在dom渲染之后
    setTimeout(()=>{
        this.getHeight();
    },300)

},
computed: {},
destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
},
activated() {

},
}
</script>
<style scoped>
.searchForm .selectIpt {position:relative; display: inline-block; border: 1px solid #DCDFE6; box-sizing: border-box; color: #606266; height: 40px; line-height: 40px; padding:0 30px 0 12px; border-radius:4px;cursor: pointer; min-width: 190px;}
.selectIpt > i { width:25px; line-height: 40px; padding:0 2.5px; color: #C0C4CC;}
.selectIpt > .iconright:before {font-size:16px;}
.selectIpt > .el-icon-circle-close:before {font-size:20px;}
.selectIpt .iconright {display: inline-block; position: absolute; right: 0; top:0;}
.selectIpt .el-icon-circle-close {display: none;position: absolute; right: 0; top:0;cursor: pointer;}
.selectIpt:hover .iconright {display: none;}
.selectIpt:hover .el-icon-circle-close {display: inline-block;}
.serialInput em {padding-left:10px;}
.serialInput .el-input {width:165px;}
.serialInput >>> .el-input__inner {padding-left:8px;}
/*刷新预警弹窗 */
.narrowDlog >>>.el-dialog{ width: 750px; }
.comTable >>> .dangerRow {background:#fef0f0;}
</style>
  


// WEBPACK FOOTER //
// src/views/StatisticsFolder/HBGReconciliationStatistics/DealerReconciliation.vue